module.exports = __webpack_public_path__ + "img/PL09162.91644ff2.png";